"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useUniqueId;

var _react = require("react");

var _mathRandom = _interopRequireDefault(require("math-random"));

/* eslint no-magic-numbers: ["error", { "ignore": [2, 5, 36] }] */
function useUniqueId(prefix) {
  var id = (0, _react.useMemo)(function () {
    return (0, _mathRandom.default)().toString(36).substr(2, 5);
  }, []);
  prefix = prefix ? "".concat(prefix, "--") : '';
  return "".concat(prefix).concat(id);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9hZGFwdGl2ZUNhcmRzL2hvb2tzL2ludGVybmFsL3VzZVVuaXF1ZUlkLnRzIl0sIm5hbWVzIjpbInVzZVVuaXF1ZUlkIiwicHJlZml4IiwiaWQiLCJ0b1N0cmluZyIsInN1YnN0ciJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBRUE7O0FBQ0E7O0FBSEE7QUFLZSxTQUFTQSxXQUFULENBQXFCQyxNQUFyQixFQUE4QztBQUMzRCxNQUFNQyxFQUFFLEdBQUcsb0JBQVE7QUFBQSxXQUFNLDJCQUFTQyxRQUFULENBQWtCLEVBQWxCLEVBQXNCQyxNQUF0QixDQUE2QixDQUE3QixFQUFnQyxDQUFoQyxDQUFOO0FBQUEsR0FBUixFQUFrRCxFQUFsRCxDQUFYO0FBRUFILEVBQUFBLE1BQU0sR0FBR0EsTUFBTSxhQUFNQSxNQUFOLFVBQW1CLEVBQWxDO0FBRUEsbUJBQVVBLE1BQVYsU0FBbUJDLEVBQW5CO0FBQ0QiLCJzb3VyY2VSb290IjoiYnVuZGxlOi8vLyIsInNvdXJjZXNDb250ZW50IjpbIi8qIGVzbGludCBuby1tYWdpYy1udW1iZXJzOiBbXCJlcnJvclwiLCB7IFwiaWdub3JlXCI6IFsyLCA1LCAzNl0gfV0gKi9cblxuaW1wb3J0IHsgdXNlTWVtbyB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCByYW5kb20gZnJvbSAnbWF0aC1yYW5kb20nO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiB1c2VVbmlxdWVJZChwcmVmaXg/OiBzdHJpbmcpOiBzdHJpbmcge1xuICBjb25zdCBpZCA9IHVzZU1lbW8oKCkgPT4gcmFuZG9tKCkudG9TdHJpbmcoMzYpLnN1YnN0cigyLCA1KSwgW10pO1xuXG4gIHByZWZpeCA9IHByZWZpeCA/IGAke3ByZWZpeH0tLWAgOiAnJztcblxuICByZXR1cm4gYCR7cHJlZml4fSR7aWR9YDtcbn1cbiJdfQ==